
module.exports={
    data:{
        count:101,
        list:[
            {
                "voteId": 1,
                "title": "自己噶时代啊啥的挂号费",
                "type": 0, //0单选，1多选
                "selectCount": 1, //最多选择几个
                "startTime":"2017-11-11 12:20:20",
                "endTime":"2017-11-11 12:20:20",
                "showStatus": 0,
                "isShowFake":1,
                "sort":0,
                "channels":[
                    {
                        "channelId":123,
                        "name":"啊啊啊"
                    },
                    {
                        "channelId":123,
                        "name":"得到的"
                    },
                    {
                        "channelId":123,
                        "name":"哈哈哈"
                    },
                ],
                "avatar":{
                    "image":"Files/04/dc/04dc1f588c837b9e0bab5c20b582651b0af9f3d8_64895.jpg",
                    "width":800,
                    "height":800
                },
                "position": 12,
                "options": [
                    {
                        "optionId":123,
                        "optionName":"啊算啊世是电话啊还是",
                        "fakeCount":100,//虚拟票
                        "voteCount":200,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊啊还是",
                        "fakeCount":300,//虚拟票
                        "voteCount":400,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界是电话啊还是",
                        "fakeCount":500,//虚拟票
                        "voteCount":600,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊还是",
                        "fakeCount":700,//虚拟票
                        "voteCount":855,//真实票数
                    },

                ] ,
                "fakeTotalCount":1600,
                "voteTotalCount":1655,
            },
            {
                "voteId": 2,
                "title": "阿斯顿发噶时代风阿斯顿发阿斯顿发阿斯顿发阿斯顿发",
                "type": 1, //0单选，1多选
                "selectCount": 19, //最多选择几个
                "startTime":"2017-11-11 12:20:20",
                "endTime":"2017-11-11 12:20:20",
                "showStatus": 1,
                "isShowFake":0,
                "sort":0,
                "channels":[
                    {
                        "channelId":123,
                        "name":"啊啊啊"
                    },
                    {
                        "channelId":123,
                        "name":"得到的"
                    },
                    {
                        "channelId":123,
                        "name":"哈哈哈"
                    },
                ],
                "avatar":{
                    "image":"Files/04/dc/04dc1f588c837b9e0bab5c20b582651b0af9f3d8_64895.jpg",
                    "width":800,
                    "height":800
                },
                "position": 12,
                "options": [
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":100,//虚拟票
                        "voteCount":200,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":300,//虚拟票
                        "voteCount":400,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":500,//虚拟票
                        "voteCount":600,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":700,//虚拟票
                        "voteCount":855,//真实票数
                    },

                ] ,
                "fakeTotalCount":1600,
                "voteTotalCount":1655,
            },
            {
                "voteId": 3,
                "title": "阿斯顿发就是对方公交卡是个打发时间的回复",
                "type": 1, //0单选，1多选
                "selectCount": null, //最多选择几个
                "startTime":"2017-11-11 12:20:20",
                "endTime":"2017-11-11 12:20:20",
                "showStatus": 2,
                "isShowFake":1,
                "sort":0,
                "channels":[
                    {
                        "channelId":123,
                        "name":"啊啊啊"
                    },
                    {
                        "channelId":123,
                        "name":"得到的"
                    },
                    {
                        "channelId":123,
                        "name":"哈哈哈"
                    },
                ],
                "avatar":{
                    "image":"Files/04/dc/04dc1f588c837b9e0bab5c20b582651b0af9f3d8_64895.jpg",
                    "width":800,
                    "height":800
                },
                "position": 12,
                "options": [
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":100,//虚拟票
                        "voteCount":200,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":300,//虚拟票
                        "voteCount":400,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":500,//虚拟票
                        "voteCount":600,//真实票数
                    },
                    {
                        "optionId":123,
                        "optionName":"啊算啊世界的风啊世界好地方啊就是电话啊还是",
                        "fakeCount":700,//虚拟票
                        "voteCount":855,//真实票数
                    },

                ] ,
                "fakeTotalCount":1600,
                "voteTotalCount":1655,
            }

        ],
    }
}
